import { createSelector } from 'reselect';

import { multiSelect } from 'react-redux-app/lib/modules/form/utils';
import { getSites } from './site';


const getSiteIdsWithAliases = state => state.site.idsWithAliases;

const getSitesWithAliases = createSelector(
  getSites,
  getSiteIdsWithAliases,
  (sites, siteIds) => siteIds.map(siteId => sites[siteId])
);

export const getSitesWithAliasesOptions = createSelector(
  getSitesWithAliases,
  sitesWithAliases => (
    [multiSelect.createOption('', null)].concat(
      sitesWithAliases.map(({ id, siteName }) => multiSelect.createOption(siteName, id))
    )
  )
);

export const getIsSitesWithAliasesLoading = state => state.site.isSitesWithAliasesLoading;
